import { Form } from 'formik';
import styled from 'styled-components';

export const Container = styled.div``;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  width: 100%;
`;

export const DivLiPhone = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) auto;
  align-items: end;
  gap: 1.5rem;
  width: 100%;

  @media screen and (max-width: ${(props) => props.theme.size?.medium}) {
    grid-template-columns: 1fr;
  }
`;

export const DivLi = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
  justify-content: space-between;
  gap: 1.5rem;

  width: 100%;
`;

export const DivLiRgCpf = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
  justify-content: space-between;
  gap: 1.5rem;

  width: 100%;

  @media screen and (max-width: ${(props) => props.theme.size?.medium}) {
    display: grid;
    grid-template-columns: 1fr;
    align-content: end;
  }
`;

export const DivAddress = styled.div``;

export const DivAddressInfo = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 1.5rem;

  :nth-child(1) {
    grid-column: 1 / span 2;
    grid-row: 1;
  }
  :nth-child(2) {
    grid-column: 3;
    grid-row: 1;
  }
  :nth-child(3) {
    grid-column: 1 / span 2;
    grid-row: 2;
  }
  :nth-child(4) {
    grid-column: 3;
    grid-row: 2;
  }
  :nth-child(5) {
    grid-column: 1;
    grid-row: 3;
  }
  :nth-child(6) {
    grid-column: 2 / span 2;
    grid-row: 3;
  }

  @media screen and (max-width: ${(props) => props.theme.size?.medium}) {
    display: grid;
    grid-template-columns: 1fr;
    align-content: end;
  }
`;

export const DivGraduation = styled.div`
  display: flex;

  justify-content: space-between;
  align-items: end;

  gap: 1.5rem;

  @media screen and (max-width: ${(props) => props.theme.size?.medium}) {
    display: grid;
    grid-template-columns: 1fr;
  }
`;

export const Button = styled.div`
  display: flex;

  justify-content: end;
  width: 100%;
`;
